import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import View from './view';
import OrthographicViewport from '../viewports/orthographic-viewport';
import OrthographicController from '../controllers/orthographic-controller';
export default class OrthographicView extends View {
  get ViewportType() {
    return OrthographicViewport;
  }

  get ControllerType() {
    return OrthographicController;
  }

}

_defineProperty(OrthographicView, "displayName", 'OrthographicView');
//# sourceMappingURL=orthographic-view.js.map